import { createPathFromRoute } from '@utils/routeGenerator';
import { createStorageKey, local } from '@utils/storage';
import { StorageKeys } from '@constants/storageKeys';
import { ExternalModalName } from '@components/modals/useOpenModalInExternalView';

export const DEFAULT_DOC_CLASS = 'Facturen';
export const DEFAULT_LIST_TYPE = 'S';
export const SEARCH_LIST_TYPE = 'SEARCH';

const getCurrentDocClass = () => {
    const storedDocClass = local.getItem(createStorageKey([StorageKeys.CurrentDocClass]));
    return storedDocClass || DEFAULT_DOC_CLASS;
};

export enum PagePath {
    dashboard = '/',
    settings = '/settings',
    configuration = '/settings/configuration',
    search = '/search/:docClass?',
    list = '/list/:docClass?/:listType?',
    firstDocument = '/document',
    document = '/document/:documentId',
    documentExternalView = '/document-external-view',
    modalExternalView = '/modal-external-view/:name',
    allDocumentsProcessed = '/all-documents-processed',
    support = '/support',
    releases = '/releases',
    releasesSam = '/releases/sam',
    supportVideos = '/support/videos',
    supportTechnicalInformation = '/support/technical-information',
    faq = '/support/faq',
    contact = '/support/contact',
    fileHandler = '/fileHandler',

    // Authentication
    login = '/login',
}

export function createSearchPath(docClass: string): string {
    return createPathFromRoute(PagePath.search, {
        ':docClass?': docClass || getCurrentDocClass(),
    });
}

export function createListPath(docClass?: string, listType?: string): string {
    return createPathFromRoute(PagePath.list, {
        ':docClass?': docClass || getCurrentDocClass(),
        ':listType?': listType !== undefined ? listType : DEFAULT_LIST_TYPE,
    });
}

export function createDocumentPath(id?: number, editMode?: boolean): string {
    const url = createPathFromRoute(PagePath.document, {
        ':documentId': id ? id.toString() : '',
    });
    return `${url}${editMode ? '?edit=true' : ''}`;
}

export function createExternalModalPath(externalModalName: ExternalModalName): string {
    return createPathFromRoute(PagePath.modalExternalView, {
        ':name': externalModalName,
    });
}
